import { createStyles } from '@mantine/core';

import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';
import { FEATURE } from '~/common/enums/feature.enum';
import { useRegistrationBonuses } from '~/domains/auth/hooks/useRegistrationBonuses';

import { RegistrationBonusBanner } from './RegistrationBonusBanner';

/**
 * Connected component that handles registration bonus data fetching and feature flag.
 * Renders the RegistrationBonusBanner when a bonus is available.
 *
 * Returns null if:
 * - Feature flag is disabled
 * - No registration bonus is available
 */
export function ConnectedRegistrationBonusBanner() {
  const isDepositMatchBonusEnabled = useIsFeatureEnabled(FEATURE.ENABLE_DEPOSIT_MATCH_BONUS);
  const { data: registrationBonusesData } = useRegistrationBonuses({
    enabled: isDepositMatchBonusEnabled,
  });
  const firstRegistrationBonus = registrationBonusesData?.data?.[0];

  if (!isDepositMatchBonusEnabled || !firstRegistrationBonus) {
    return null;
  }

  return (
    <RegistrationBonusBanner bonus={firstRegistrationBonus} />
  );
}
